/**
 * Created by lihanying on 2017/6/20.
 */


export const GETPORTALSUCCESS = 'GETPORTALSUCCESS'


// WEBPACK FOOTER //
// ./src/containers/Portal/constants.js